import * as fmt from "../util/fmt_utils"
import { alerts } from "../util/alert_error_utils"
import * as client from "../api/client"

// Reset all state
// actions

export const RESET = "RESET"
export function reset() {
    return {
        type: RESET,
    }
}

export const RESET_RUNNING_TIME_ENTRIES = "RESET_RUNNING_TIME_ENTRIES"
export function resetRunningTimeEntries() {
    return {
        type: RESET_RUNNING_TIME_ENTRIES,
    }
}

export const SET_BOOTSTRAPPED = "SET_BOOTSTRAPPED"
export function setBootstrapped(bool) {
    return {
        bootstrapped: bool,
        type: SET_BOOTSTRAPPED,
    }
}

export const START_BOOTSTRAP = "START_BOOTSTRAP"
export function startBootstrap() {
    return {
        type: START_BOOTSTRAP,
    }
}

// viewport (pagination date range)

export const SET_DASHBOARD_RANGE = "SET_DASHBOARD_RANGE"
export function setDashboardRange(range) {
    return {
        range,
        type: SET_DASHBOARD_RANGE,
    }
}

export const SET_DASHBOARD_HORIZON = "SET_DASHBOARD_HORIZON"
export function setDashboardHorizon(horizon) {
    return {
        horizon,
        type: SET_DASHBOARD_HORIZON,
    }
}

export const SET_DASHBOARD_DISPLAY = "SET_DASHBOARD_DISPLAY"
export function setDashboardDisplay(display) {
    return {
        display,
        type: SET_DASHBOARD_DISPLAY,
    }
}

export const SET_DASHBOARD_COLLAPSE = "SET_DASHBOARD_COLLAPSE"
export function setDashboardCollapse(collapse) {
    return {
        collapse,
        type: SET_DASHBOARD_COLLAPSE,
    }
}

export const SET_DASHBOARD_GROUP_BY = "SET_DASHBOARD_GROUP_BY"
export function setDashboardGroupBy(groupBy) {
    return {
        groupBy,
        type: SET_DASHBOARD_GROUP_BY,
    }
}

// time entries
export const DOWNLOAD_CSV = "DOWNLOAD_CSV"
export function downloadCsv(params) {
    return {
        type: DOWNLOAD_CSV,
        params,
    }
}

export const PUSH_REPORT_TO_ZAPIER = "PUSH_REPORT_TO_ZAPIER"
export function pushReportToZapier(params) {
    return {
        type: PUSH_REPORT_TO_ZAPIER,
        params,
    }
}

export const FETCH_TIME_ENTRIES = "FETCH_TIME_ENTRIES"
export function fetchTimeEntries(params) {
    return {
        params,
        type: FETCH_TIME_ENTRIES,
    }
}

export const FETCH_RUNNING_TIME_ENTRIES = "FETCH_RUNNING_TIME_ENTRIES"
export function fetchRunningTimeEntries(params) {
    return {
        params,
        type: FETCH_RUNNING_TIME_ENTRIES,
    }
}

export const RECEIVE_TIME_ENTRIES = "RECEIVE_TIME_ENTRIES"
export function receiveTimeEntries(timeEntries) {
    return {
        timeEntries,
        type: RECEIVE_TIME_ENTRIES,
    }
}

export const MERGE_TIME_ENTRIES = "MERGE_TIME_ENTRIES"
export function mergeTimeEntries(timeEntries) {
    return {
        timeEntries,
        type: MERGE_TIME_ENTRIES,
    }
}

export const CREATE_TIME_ENTRY = "CREATE_TIME_ENTRY"
export function createTimeEntry(timeEntry) {
    return {
        timeEntry,
        type: CREATE_TIME_ENTRY,
    }
}

export const UPDATE_TIME_ENTRY = "UPDATE_TIME_ENTRY"
export function updateTimeEntry(timeEntry) {
    return {
        timeEntry,
        type: UPDATE_TIME_ENTRY,
    }
}

export function stopTimeEntry(timeEntry) {
    return {
        timeEntry: {
            ...timeEntry,
            endAt: Date.now(),
        },
        type: UPDATE_TIME_ENTRY,
    }
}

export const RECEIVE_TIME_ENTRY = "RECEIVE_TIME_ENTRY"
export function receiveTimeEntry(timeEntry) {
    return {
        timeEntry: fmt.convertTimeEntryToJs(timeEntry),
        type: RECEIVE_TIME_ENTRY,
    }
}

export const REMOVE_TIME_ENTRY = "REMOVE_TIME_ENTRY"
export function removeTimeEntry(timeEntry) {
    return {
        timeEntry,
        type: REMOVE_TIME_ENTRY,
    }
}

export const DELETE_TIME_ENTRY = "DELETE_TIME_ENTRY"
export function deleteTimeEntry(timeEntry) {
    return {
        timeEntry,
        type: DELETE_TIME_ENTRY,
    }
}

export const ADD_RUNNING_TIME_ENTRY_ID = "ADD_RUNNING_TIME_ENTRY_ID"
export function addRunningTimeEntryId(userId, id) {
    return {
        userId,
        id,
        type: ADD_RUNNING_TIME_ENTRY_ID,
    }
}

export const SET_RUNNING_TIME_ENTRY_IDS = "SET_RUNNING_TIME_ENTRY_IDS"
export function setRunningTimeEntryIds(userId, ids) {
    return {
        userId,
        ids,
        type: SET_RUNNING_TIME_ENTRY_IDS,
    }
}

export const REMOVE_RUNNING_TIME_ENTRY_ID = "REMOVE_RUNNING_TIME_ENTRY_ID"
export function removeRunningTimeEntryId(userId, id) {
    return {
        userId,
        id,
        type: REMOVE_RUNNING_TIME_ENTRY_ID,
    }
}

// tags

export const RECEIVE_TAGS = "RECEIVE_TAGS"
export function receiveTags(tags) {
    return {
        tags,
        type: RECEIVE_TAGS,
    }
}

export const CREATE_TAG = "CREATE_TAG"
export function createTag(tag, goal) {
    return {
        tag,
        goal,
        type: CREATE_TAG,
    }
}

export const DELETE_TAG = "DELETE_TAG"
export function deleteTag(tag) {
    return {
        tag,
        type: DELETE_TAG,
    }
}

export const REMOVE_TAG = "REMOVE_TAG"
export function removeTag(tag) {
    return {
        tag: tag,
        type: REMOVE_TAG,
    }
}

export const REMOVE_TAG_BY_TEAM_ID = "REMOVE_TAG_BY_TEAM_ID"
export function removeTagByTeamId(teamId) {
    return {
        teamId: teamId,
        type: REMOVE_TAG_BY_TEAM_ID,
    }
}

export const RECEIVE_TAG = "RECEIVE_TAG"
export function receiveTag(tag) {
    return {
        tag,
        type: RECEIVE_TAG,
    }
}

export const FETCH_TAGS = "FETCH_TAGS"
export function fetchTags(params) {
    return {
        params,
        type: FETCH_TAGS,
    }
}

export const UPDATE_TAG = "UPDATE_TAG"
export function updateTag(tag, goal, deleteGoal) {
    return {
        tag,
        goal,
        deleteGoal,
        type: UPDATE_TAG,
    }
}

export const GET_RECENT_TAG_COMBOS = "GET_RECENT_TAG_COMBOS"
export function getRecentTagCombos() {
    return {
        type: GET_RECENT_TAG_COMBOS,
    }
}

export const GET_RECENT_TAGS = "GET_RECENT_TAGS"
export function getRecentTags(params) {
    return {
        type: GET_RECENT_TAGS,
        params,
    }
}

export const RECEIVE_RECENT_TAG_COMBOS = "RECEIVE_RECENT_TAG_COMBOS"
export function receiveRecentTagCombos(recentTagCombos) {
    return {
        type: RECEIVE_RECENT_TAG_COMBOS,
        recentTagCombos,
    }
}

export const RECEIVE_RECENT_TAGS = "RECEIVE_RECENT_TAGS"
export function receiveRecentTags(recentTags) {
    return {
        type: RECEIVE_RECENT_TAGS,
        recentTags,
    }
}

export const ADD_RECENT_TAG_COMBO = "ADD_RECENT_TAG_COMBO"
export function addRecentTagCombo(recentTagCombo) {
    return {
        type: ADD_RECENT_TAG_COMBO,
        recentTagCombo,
    }
}

// tag reports

export const QUERY_TAG_REPORTS = "QUERY_TAG_REPORTS"
export function queryTagReports({ queries, team, user, reportOption }) {
    return {
        type: QUERY_TAG_REPORTS,
        queries,
        team,
        user,
        reportOption,
    }
}

export const RECEIVE_TAG_REPORTS = "RECEIVE_TAG_REPORTS"
export function receiveTagReports(tagReports) {
    return {
        type: RECEIVE_TAG_REPORTS,
        tagReports,
    }
}

export const CLEAR_TAG_REPORTS = "CLEAR_TAG_REPORTS"
export function clearTagReports() {
    return {
        type: CLEAR_TAG_REPORTS,
    }
}

// profile

export const GET_PROFILE = "GET_PROFILE"
export function getProfile() {
    return {
        type: GET_PROFILE,
    }
}

export const RECEIVE_PROFILE_V2 = "RECEIVE_PROFILE_V2"
export function receiveProfile(profile) {
    return {
        type: RECEIVE_PROFILE_V2,
        profile,
    }
}

export const HARD_RESET = "HARD_RESET"
export function hardReset() {
    return {
        type: HARD_RESET,
    }
}

export const SIGNOUT = "SIGNOUT"
export function signOut() {
    return {
        type: SIGNOUT,
    }
}

export const SIGNIN = "SIGNIN"
export function signIn(accountMeta) {
    return {
        type: SIGNIN,
        accountMeta,
    }
}

export const SIGNUP = "SIGNUP"
export function signUp(accountMeta, history) {
    return {
        type: SIGNUP,
        accountMeta,
        history,
    }
}

export const HANDLE_STRIPE_TOKEN = "HANDLE_STRIPE_TOKEN"
export function handleStripeToken({ stripeTokenMeta }) {
    return {
        type: HANDLE_STRIPE_TOKEN,
        stripeTokenMeta,
    }
}

export const HANDLE_CANCEL_PLAN = "HANDLE_CANCEL_PLAN"
export function handleCancelPlan() {
    return {
        type: HANDLE_CANCEL_PLAN,
    }
}

export const HANDLE_CHANGE_PAYMENT_METHOD = "HANDLE_CHANGE_PAYMENT_METHOD"
export function handleChangePaymentMethod(name, stripe) {
    return {
        type: HANDLE_CHANGE_PAYMENT_METHOD,
        name,
        stripe,
    }
}

export const VERIFY_EMAIL = "VERIFY_EMAIL"
export function verifyEmail(code, history) {
    return {
        type: VERIFY_EMAIL,
        code,
        history,
    }
}

// teams

export const RECEIVE_TEAMS = "RECEIVE_TEAMS"
export function receiveTeams(teams) {
    return {
        teams,
        type: RECEIVE_TEAMS,
    }
}

export const CREATE_TEAM = "CREATE_TEAM"
export function createTeam(team, history) {
    return {
        team,
        history,
        type: CREATE_TEAM,
    }
}

export const SEND_BULK_INVITES = "SEND_BULK_INVITES"
export function sendBulkInvites(fields, teamId) {
    return {
        fields,
        teamId,
        type: SEND_BULK_INVITES,
    }
}

export const RECEIVE_TEAM = "RECEIVE_TEAM"
export function receiveTeam(team) {
    return {
        team,
        type: RECEIVE_TEAM,
    }
}

export const REMOVE_TEAM = "REMOVE_TEAM"
export function removeTeam(teamId) {
    return {
        teamId,
        type: REMOVE_TEAM,
    }
}

export const UPDATE_TEAM = "UPDATE_TEAM"
export function updateTeam(team) {
    return {
        team,
        type: UPDATE_TEAM,
    }
}

// users

export const RECEIVE_USERS = "RECEIVE_USERS"
export function receiveUsers(users) {
    return {
        users,
        type: RECEIVE_USERS,
    }
}

export const RECEIVE_USER = "RECEIVE_USER"
export function receiveUser(user) {
    return {
        user,
        type: RECEIVE_USER,
    }
}

export const UPDATE_USER_NAME = "UPDATE_USER_NAME"
export const updateUserName = name => ({
    name,
    type: UPDATE_USER_NAME,
})

export const UPDATE_USER_TIMEZONE = "UPDATE_USER_TIMEZONE"
export const updateUserTimezone = timezone => ({
    timezone,
    type: UPDATE_USER_TIMEZONE,
})

export const SET_FORCE_V1 = "SET_FORCE_V1"
export function setForceV1(bool) {
    return {
        forceV1: bool,
        type: SET_FORCE_V1,
    }
}

export const UPDATE_NOTIFICATION_PREFERENCES = "UPDATE_NOTIFICATION_PREFERENCES"
export const updateNotificationPreferences = notificationPreferences => ({
    type: UPDATE_NOTIFICATION_PREFERENCES,
    notificationPreferences,
})

export const SELECT_TEAM_DASHBOARD = "SELECT_TEAM_DASHBOARD"
export function selectTeamDashboard(teamId) {
    return {
        teamId: teamId,
        type: SELECT_TEAM_DASHBOARD,
    }
}

export const RECEIVE_TEAM_DASHBOARD = "RECEIVE_TEAM_DASHBOARD"
export function receiveTeamDashboard(teamId) {
    return {
        teamId: teamId,
        type: RECEIVE_TEAM_DASHBOARD,
    }
}

export const FETCH_CURRENT_HORIZON = "FETCH_CURRENT_HORIZON"
export function fetchCurrentHorizon() {
    return {
        type: FETCH_CURRENT_HORIZON,
    }
}


export const ACCEPT_TEAM_INVITE = "ACCEPT_TEAM_INVITE"
export function acceptTeamInvite(inviteId, history) {
    return { type: ACCEPT_TEAM_INVITE, inviteId, history }
}

export const SET_CURRENT_INVITE = "SET_CURRENT_INVITE"
export const setCurrentInvite = (currentInvite) => ({
    type: SET_CURRENT_INVITE, 
    currentInvite,
})

// team members

export const RECEIVE_TEAM_MEMBERS = "RECEIVE_TEAM_MEMBERS"
export function receiveTeamMembers(teamId, teamMembers) {
    return {
        type: RECEIVE_TEAM_MEMBERS,
        teamId,
        teamMembers,
    }
}

export const UPDATE_MEMBER_ROLE = "UPDATE_MEMBER_ROLE"
export function updateMemberRole(teamMember, role) {
    return {
        type: UPDATE_MEMBER_ROLE,
        teamMember,
        role,
    }
}

// team invites

export const RECEIVE_TEAM_INVITES = "RECEIVE_TEAM_INVITES"
export function receiveTeamInvites(teamId, teamInvites) {
    return {
        type: RECEIVE_TEAM_INVITES,
        teamId,
        teamInvites,
    }
}

export const DELETE_INVITE = "DELETE_INVITE"
export function deleteInvite(inviteId) {
    return {
        inviteId: inviteId,
        type: DELETE_INVITE,
    }
}

export const HANDLE_DISABLE_MEMBER = "HANDLE_DISABLE_MEMBER"
export function handleDisableMember(member) {
    return {
        member: member,
        type: HANDLE_DISABLE_MEMBER,
    }
}

export const HANDLE_ADD_MEMBER = "HANDLE_ADD_MEMBER"
export function handleAddMember(member) {
    return {
        member: member,
        type: HANDLE_ADD_MEMBER,
    }
}

export const REMOVE_MEMBER = "REMOVE_MEMBER"
export function removeMember(member) {
    return {
        member: member,
        type: REMOVE_MEMBER,
    }
}

export const REMOVE_INVITE = "REMOVE_INVITE"
export function removeInvite(inviteId) {
    return {
        inviteId: inviteId,
        type: REMOVE_INVITE,
    }
}

export const CREATE_INVITE = "CREATE_INVITE"
export function createInvite(invite) {
    return {
        invite: invite,
        type: CREATE_INVITE,
    }
}

// goals

export const RECEIVE_GOAL = "RECEIVE_GOAL"
export function receiveGoal(goal) {
    return {
        goal,
        type: RECEIVE_GOAL,
    }
}

export const CREATE_GOAL = "CREATE_GOAL"
export function createGoal(goal) {
    return {
        goal,
        type: CREATE_GOAL,
    }
}

export const DELETE_GOAL = "DELETE_GOAL"
export function deleteGoal(goal) {
    return {
        goal,
        type: DELETE_GOAL,
    }
}

export const REMOVE_GOAL = "REMOVE_GOAL"
export function removeGoal(goal) {
    return {
        goal: goal,
        type: REMOVE_GOAL,
    }
}

export const REMOVE_GOAL_BY_TEAM_ID = "REMOVE_GOAL_BY_TEAM_ID"
export function removeGoalByTeamId(teamId) {
    return {
        teamId: teamId,
        type: REMOVE_GOAL_BY_TEAM_ID,
    }
}

export const RECEIVE_GOALS = "RECEIVE_GOALS"
export function receiveGoals(goals) {
    return {
        goals,
        type: RECEIVE_GOALS,
    }
}

export const FETCH_GOALS = "FETCH_GOALS"
export function fetchGoals(params) {
    return {
        params,
        type: FETCH_GOALS,
    }
}

export const FETCH_GOAL = "FETCH_GOAL"
export function fetchGoal(goalId) {
    return {
        goalId,
        type: FETCH_GOAL,
    }
}

export const SET_ALERTS = "SET_ALERTS"
export function setAlerts(alert, page, ...vars) {
    return {
        alert: alerts[alert],
        page: page,
        vars: vars,
        type: SET_ALERTS,
    }
}

// Customer
export const FETCH_TEAM_ACCOUNT_CUSTOMER = "FETCH_TEAM_ACCOUNT_CUSTOMER"
export function fetchTeamAccountCustomer(teamId) {
    return {
        type: FETCH_TEAM_ACCOUNT_CUSTOMER,
        teamId,
    }
}

export const RECEIVE_CUSTOMER = "RECEIVE_CUSTOMER"
export function receiveCustomer(customer) {
    return {
        customer,
        type: RECEIVE_CUSTOMER,
    }
}

export const CLEAR_CUSTOMER = "CLEAR_CUSTOMER"
export function clearCustomer() {
    return {
        type: CLEAR_CUSTOMER,
    }
}

// Account

export const RECEIVE_ACCOUNTS = "RECEIVE_ACCOUNTS"
export function receiveAccounts(accounts) {
    return {
        accounts,
        type: RECEIVE_ACCOUNTS,
    }
}

export const UPDATE_ACCOUNT_NAME = "UPDATE_ACCOUNT_NAME"
export const updateAccountName = companyName => ({
    companyName,
    type: UPDATE_ACCOUNT_NAME,
})

// Ui

export const SET_UI_NOTIFICATION_PREFERENCES = "SET_UI_NOTIFICATION_PREFERENCES"
export function setUiNotificationPreferences(notificationPreferences) {
    return {
        type: SET_UI_NOTIFICATION_PREFERENCES,
        notificationPreferences,
    }
}

export const SET_UI_PW_MODAL_OPEN = "SET_UI_PW_MODAL_OPEN"
export function setUiPwModalOpen(pwModalOpen) {
    return {
        type: SET_UI_PW_MODAL_OPEN,
        pwModalOpen,
    }
}

export const SET_PAYMENT_MODAL_OPEN = "SET_PAYMENT_MODAL_OPEN"
export function setPaymentModalOpen(paymentModalOpen) {
    return {
        type: SET_PAYMENT_MODAL_OPEN,
        paymentModalOpen,
    }
}

export const SET_SELECTED_SIDEBAR_TAB = "SET_SELECTED_SIDEBAR_TAB"
export function setSelectedSidebarTab(selectedSidebarTab) {
    return {
        type: SET_SELECTED_SIDEBAR_TAB,
        selectedSidebarTab,
    }
}

export const SET_SELECTED_ADMIN_TAB = "SET_SELECTED_ADMIN_TAB"
export function setSelectedAdminTab(selectedAdminTab) {
    return {
        type: SET_SELECTED_ADMIN_TAB,
        selectedAdminTab,
    }
}

export const HANDLE_NAVIGATE_AND_FETCH_ACCOUNT_CUSTOMER =
    "HANDLE_NAVIGATE_AND_FETCH_ACCOUNT_CUSTOMER"
export function handleNavigateAndFetchAccountCustomer(history) {
    return {
        type: HANDLE_NAVIGATE_AND_FETCH_ACCOUNT_CUSTOMER,
        history,
    }
}

export const HANDLE_NAVIGATE_AND_PATCH = "HANDLE_NAVIGATE_AND_PATCH"
export function handleNavigateAndPatch(patchMeta, history) {
    return {
        type: HANDLE_NAVIGATE_AND_PATCH,
        patchMeta,
        history,
    }
}

export const SET_IS_LOADING = "SET_IS_LOADING"
export function setIsLoading(isLoading) {
    return {
        type: SET_IS_LOADING,
        isLoading,
    }
}

export const SET_SELECTED_SETTINGS_TAB = "SET_SELECTED_SETTINGS_TAB"
export function setSelectedSettingsTab(selectedSettingsTab) {
    return {
        type: SET_SELECTED_SETTINGS_TAB,
        selectedSettingsTab,
    }
}

export const SET_UI = "SET_UI"
export const setUI = ui => ({
    type: SET_UI,
    ui,
})

// change Password (logged in)

export const CHANGE_PASSWORD = "CHANGE_PASSWORD"
export function changePassword(currentPassword, newPassword) {
    return {
        currentPassword,
        newPassword,
        type: CHANGE_PASSWORD,
    }
}

// password reset

export const FORGOT_PASSWORD = "FORGOT_PASSWORD"
export function forgotPassword(email) {
    return {
        email,
        type: FORGOT_PASSWORD,
    }
}

export function resetPassword(accountMeta, page) {
    return dispatch =>
        client
            .resetPassword(accountMeta)
            .then(
                () => dispatch(setAlerts("passwordReset", page)),
                () => dispatch(setAlerts("badResetToken", page)),
            )
}

export function authedPasswordReset(accountMeta, newAccountMeta, page) {
    return dispatch =>
        client
            .signIn(accountMeta)
            .then(
                () => dispatch(resetPassword(newAccountMeta, page)),
                () => dispatch(setAlerts("incorrectPassword", page)),
            )
}

// sockets

export const SOCKET_STATUS_CHANGE = "SOCKET_STATUS_CHANGE"
export function socketStatusChange(status) {
    return {
        status,
        type: SOCKET_STATUS_CHANGE,
    }
}

const RECEIVE_SOCKET_EVENT = "RECEIVE_SOCKET_EVENT"
export function receiveSocketEvent(event, object) {
    return {
        event,
        object,
        type: RECEIVE_SOCKET_EVENT,
    }
}

// oauth
export const START_GOOGLE_AUTH = "START_GOOGLE_AUTH"
export function startGoogleAuth(oauthPopup) {
    return {
        type: START_GOOGLE_AUTH,
        oauthPopup,
    }
}
const HANDLE_WEBSOCKET_ACCOUNTS_UPDATED = "HANDLE_WEBSOCKET_ACCOUNTS_UPDATED"
export function handleWebsocketAccountsUpdated(id) {
    return {
        id,
        type: HANDLE_WEBSOCKET_ACCOUNTS_UPDATED,
    }
}

const HANDLE_WEBSOCKET_CUSTOMER_UPDATED = "HANDLE_WEBSOCKET_CUSTOMER_UPDATED"
export function handleWebsocketCustomerUpdated(id) {
    return {
        id,
        type: HANDLE_WEBSOCKET_CUSTOMER_UPDATED,
    }
}

// resend verification code
const RESEND_VERIFICATION_CODE = "RESEND_VERIFICATION_CODE"
export function resendVerificationCode() {
    return {
        type: RESEND_VERIFICATION_CODE,
    }
}



// WEBPACK FOOTER //
// ./src/redux/action_creators.js